import authRules from '../authRules';

const addDayTypeRequest = (user) => {
  const { absenceRequests } = user.securityLevels;
  if (absenceRequests >= authRules.addDayTypeRequest.absenceRequests) {
      return true;
  } else {
      return false;
    }
  }


export default addDayTypeRequest;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addDayTypeRequest.js